import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {ClientVolumesModel} from "./client-volumes.model";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";

@Injectable()
export class ClientVolumesService implements IDataModel {

    private API_ROOT:string = '/clients/volumes';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<ClientVolumesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientVolumesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/volumes`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getListByClientInterval(clientId:number, type:string, from?: string, to?: string): Observable<ListResponseModel<ClientVolumesModel>>  {

        let params: URLSearchParams = new URLSearchParams();
        params.set('interval', type);
        params.set('from', from);
        params.set('to', to);

        let requestOptions = new RequestOptions();
        requestOptions.search = params;

        return this.http
            .get(`/clients/${clientId}/volumes`, requestOptions)
            .map((res) => res.json());
    }

    getOne(id:number):Observable<ResponseModel<ClientVolumesModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:ClientVolumesModel): Observable<ResponseModel<ClientVolumesModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:ClientVolumesModel): Observable<ResponseModel<ClientVolumesModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    bulkEdit(volumes:any) {
        return this.http.put(`${this.API_ROOT}`, volumes).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/client-volumes/client-volumes.service.ts